import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from '../config'

class PaymentStore {
  payment = [];
  vehiclePayment = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      payment: observable,
      vehiclePayment: observable,
      total: observable,
      loading: observable,
      loadData: action,
      loadPaymentList: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, companyId, paymentType }) {

    this.loading = true;
    var postData = { companyId: companyId, paymentType: paymentType, offset: offset, limit: limit };

    if (config.pythonReport === 1) {
      var response = await postApi
        .getClient()
        .post(config.NodeUrl + "/payment/paymentList",
          postData,
        );
        // .post("http://localhost:3061/payment/paymentList",
        //   postData,
        // );
    }else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=payments&a=getPayment", "postData=" + base64Input);
    }

    this.payment = response?.data?.data.paymentList;
    this.loading = false;

  }

  async loadPaymentList({ companyId, paymentId }) {

    this.loading = true;
    var postData = { companyId: companyId, paymentId: paymentId };

    if (config.pythonReport === 1) {

      var response = await postApi
        .getClient()
        .post(config.NodeUrl + "/payment/getVehiclePayment",
          postData,
        );
        // .post("http://localhost:3061/payment/getVehiclePayment",
        //   postData,
        // );

    }else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=payments&a=getVehiclePayment",
          "postData=" + base64Input
        );
    }

    this.vehiclePayment = response?.data?.data.paymentVehicleList;
    this.loading = false;

  }
}

export default PaymentStore;
